export default status => {
  return status !== 'cancelled' && status !== 'closed' && status !== 'tooLate' && status !== 'closedNotAmendable'
}
